import React, { PropsWithChildren } from 'react';
import { Loader } from 'fronton-react';
import { LoadingDimmerWrapper, BlurArea } from './styles';

interface ILoadingDimmer {
  active: boolean;
}

export const LoadingDimmer: React.FC<PropsWithChildren<ILoadingDimmer>> = ({ children, active }) => {
  return (
    <LoadingDimmerWrapper active={active}>
      {active ? <Loader data-qa="dimmer-loader" variant="primary" className="loader" size="l" /> : null}
      <BlurArea active={active}>{children}</BlurArea>
    </LoadingDimmerWrapper>
  );
};
